export const API: string | undefined = process.env.REACT_APP_HOST_HOST_API;
export const GET = 'GET';
